function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M117.5 60C117.5 91.4802 91.9802 117 60.5 117C29.0198 117 3.5 91.4802 3.5 60C3.5 28.5198 29.0198 3 60.5 3C91.9802 3 117.5 28.5198 117.5 60Z",
  stroke: "#E71A90",
  strokeWidth: 6
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M48.5 89H75.5C77.99 89 80.12 87.5 81.02 85.34L90.08 64.19C90.35 63.5 90.5 62.78 90.5 62V56C90.5 52.7 87.8 50 84.5 50H63.5L65.42 38.29L65.51 37.33C65.51 36.1 65 34.96 64.19 34.15L61.01 31L44.24 48.77C43.16 49.85 42.5 51.35 42.5 53V83C42.5 86.3 45.2 89 48.5 89ZM46.5 53L61.5 36.5L58.5 54H86.5V62L76.5 85H46.5V53ZM32.5 53H38.5V89H32.5V53Z",
  fill: "#E71A90"
});

function SvgCeramicLike(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 120,
    viewBox: "0 0 121 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCeramicLike);
export default __webpack_public_path__ + "static/media/ceramicLike.5669f5ea.svg";
export { ForwardRef as ReactComponent };